import { TestInstrument } from '../lab-test/test-instrument.model';
import { OnBoardingAnalyte } from './onboarding-analyte.model';
import { OnBoardingInput } from './onboarding-input.model';

export class OnBoardingInstrument {
    instrument: TestInstrument;
    inputData: OnBoardingInput;
    // Todo: Remove these two properties
    isAllTestsCompleted: boolean;
    unCompletedTestCount: number;
    isSelected: boolean;
    isProcessing: boolean;
}



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/contracts/onboarding/onboarding-instrument.model.ts